import { sendTestEmail as sendTestEmailApiCall } from "@api/campaign.api";

import { PopupActions } from "@store/popupStore";

const sendTestEmail = async (campaignId: string, testEmailAddress: string) => {
  try {
    await sendTestEmailApiCall(campaignId, testEmailAddress);
    PopupActions.openAlert({
      duration: 5000,
      message: `Test email sent to ${testEmailAddress}`,
      severity: "success",
    });
  } catch {
    PopupActions.openNotification({
      content: "There was an issue sending the test email. Please try again.",
      title: "Error",
    });
  }
};

export default { sendTestEmail };
